import { render } from "./AccountModal.vue?vue&type=template&id=3578eccd"
import script from "./AccountModal.vue?vue&type=script&lang=js"
export * from "./AccountModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__